<ng-container *transloco="let t; read: 'login'">
  <div *ngrxLet="isVerifyEmailMode$ as isVerifyEmailMode" [ngClass]="{ 'login-container': isVerifyEmailMode }">
    <div [ngClass]="{ 'login-container__content': isVerifyEmailMode }">
      <div class="login__header">
        <a class="login__logo-link" href="https://www.helplinesoftware.com/" rel="noopener" target="_blank">
          <img alt="Helpline Software" class="login__logo" src="/assets/logos/helpline-software.svg" />
        </a>
        <h1 class="login__title">{{ t('title') }}</h1>
      </div>

      <form class="login__form">
        <label *ngrxLet="form.controls.email as emailControl" class="login__form-field">
          <span class="login__form-field-label">{{ t('emailField.label') }}</span>

          <input
            class="login__form-field-input"
            pInputText
            type="email"
            [formControl]="emailControl"
            [placeholder]="t('emailField.placeholder')"
          />

          <app-form-field-help [control]="emailControl">
            <ng-container *ngIf="emailControl.errors as emailErrors" form-field-help-errors>
              <ng-container *ngIf="emailErrors.required">{{ t('emailField.requiredError') }}</ng-container>
              <ng-container *ngIf="emailErrors.email">{{ t('emailField.invalidError') }}</ng-container>
            </ng-container>
          </app-form-field-help>
        </label>

        <label *ngrxLet="form.controls.password as passwordControl" class="login__form-field">
          <span class="login__form-field-label">{{ t('passwordField.label') }}</span>

          <span *ngrxLet="showPassword$ as showPassword" class="p-input-icon-right">
            <i
              class="pi"
              role="button"
              [attr.aria-label]="t('passwordField.toggleVisibilityButtonLabel')"
              [ngClass]="{
                'pi-eye': !showPassword,
                'pi-eye-slash': showPassword,
              }"
              (click)="toggleShowPassword()"
            ></i>
            <input
              class="login__form-field-input"
              pInputText
              [formControl]="passwordControl"
              [placeholder]="t('passwordField.placeholder')"
              [type]="showPassword ? 'text' : 'password'"
            />
          </span>

          <app-form-field-help [control]="passwordControl">
            <ng-container *ngIf="passwordControl.errors as passwordErrors" form-field-help-errors>
              <ng-container *ngIf="passwordErrors.required">{{ t('passwordField.requiredError') }}</ng-container>
            </ng-container>
          </app-form-field-help>
        </label>

        <div class="login__form-actions">
          <label class="login__form-actions-checkbox">
            <p-checkbox [binary]="true" [formControl]="form.controls.acceptTermsAndPrivacyPolicy"></p-checkbox>
            <span [innerHTML]="t('acceptTermsAndPrivacyPolicy')"> </span>
          </label>

          <a routerLink="/auth/forgot-password" tabindex="0">{{ t('forgotPassword') }}</a>
        </div>

        <p-messages [closable]="false"></p-messages>
      </form>

      <div class="login__actions">
        <button
          *ngrxLet="loading$ as loading"
          class="login__actions-button"
          pButton
          [attr.aria-busy]="loading"
          [disabled]="form.invalid || loading"
          [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-user'"
          [label]="loading ? '' : t('signInButtonLabel')"
          [class.login__actions-button--loading]="loading"
          (click)="login()"
        ></button>
      </div>

      <div class="login__footer">
        <div class="login__footer-attribution">
          <i class="pi pi-shield"></i>
          <span
            >Powered by
            <a href="https://www.helplinesoftware.com/" rel="noopener" target="_blank">Helpline Software</a></span
          >
        </div>
        <nav class="login__footer-links">
          <a href="https://www.helplinesoftware.com/" rel="noopener" target="_blank">Home</a>
          <a href="https://www.helplinesoftware.com/pricing" rel="noopener" target="_blank">Pricing</a>
          <a href="https://www.helplinesoftware.com/about" rel="noopener" target="_blank">About</a>
          <a href="https://www.helplinesoftware.com/contact" rel="noopener" target="_blank">Contact</a>
        </nav>
      </div>
    </div>
  </div>
</ng-container>
